function getAbilities() {
    return window.axios.get('/api/user/abilities');
}
export default {
    getAbilities
}